import axios from 'axios';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export interface ICD10CodeT {
  code: string;
  description: string;
}

export interface SearchICD10RequestT {
  query: string;
  mode: 'fulltextsearch' | 'embedding';
  topK: number;
}

export interface SearchICD10ResponseT {
  codes: ICD10CodeT[];
}

export async function fetchSearchICD10(
  request: SearchICD10RequestT,
  signal?: AbortSignal
): Promise<SearchICD10ResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await axios.post<SearchICD10ResponseT>(
    '/greenfield/care/labs/icd10/search',
    { query: request.query, mode: request.mode, top_k: request.topK },
    config
  );
  return response.data;
}
